import React from 'react';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Modal from '..';
import classes from './ConfirmModal2.module.scss';

import { getEnv } from '@config';

const { publicPath } = getEnv();

export default function ({
  title,
  subTitle,
  image,
  handleConfirm,
  textConfirm,
  handleCancel,
  textCancel,
  open,
  imageSource,
  imageStyle,
  extraWidth,
  cancelButtonSizeInLargeScreen = 6,
  maxWidthButtons = true,
  disableDefaultHandleClose = false,
}) {
  const classesFade = [classes.fade];
  if (extraWidth) {
    classesFade.push(classes.extraWidth);
  }
  const imgSrc = image ? `${publicPath}/${image}` : imageSource;
  return (
    <Modal
      className={classes.modal}
      open={open}
      style={{ textAlign: 'center' }}
      fadeClass={classesFade.join(' ')}
      handleClose={disableDefaultHandleClose ? undefined : handleCancel}
    >
      <Grid item container className={classes.container}>
        {imgSrc && (
          <Grid item xs={12}>
            <img src={imgSrc} style={imageStyle} alt="Imagen de precaucion" />
          </Grid>
        )}
        <Grid item xs={12}>
          <h2>{title}</h2>
        </Grid>
        <Grid item xs={12}>
          <h3>{subTitle}</h3>
        </Grid>
      </Grid>
      <Grid item container xs={12} direction="row-reverse">
        <Grid
          item
          xs={12}
          lg={textCancel && handleCancel ? 12 - cancelButtonSizeInLargeScreen : 12}
        >
          <Button
            id="confirm"
            onClick={handleConfirm}
            className={[classes.button, !maxWidthButtons && classes.fullWidth].join(' ')}
          >
            {textConfirm}
          </Button>
        </Grid>
        {textCancel && handleCancel && (
          <Grid item xs={12} lg={cancelButtonSizeInLargeScreen}>
            <Button
              id="cancel"
              onClick={handleCancel}
              className={[
                classes.button,
                classes.cancelButton,
                'button_text',
                !maxWidthButtons && classes.fullWidth,
              ].join(' ')}
            >
              {textCancel}
            </Button>
          </Grid>
        )}
      </Grid>
    </Modal>
  );
}
